import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UiOverlayService } from '@cynteka/ui-kit';
import { AiChatSessionRenameDialogComponent } from '../templates/ai-chat-session-rename-dialog/ai-chat-session-rename-dialog.component';

@Injectable({ providedIn: 'root' })
export class AiChatSessionRenameService {
    public constructor(private readonly overlayService: UiOverlayService) {}

    /**
     * Открывает модалку редактирования названия диалога.
     * @returns новое название или `null`, если пользователь отменил / закрыл окно.
     */
    public open(currentTitle: string): Observable<string | null> {
        const modal = this.overlayService.createModalOverlay({
            title: 'Редактировать название',
            size: 'small',
            closeOnBackdrop: true,
            showCloseButton: true,
            contentComponent: AiChatSessionRenameDialogComponent,
            actionButtons: [
                {
                    label: 'Отмена',
                    color: 'secondary-neutral',
                    size: 'large',
                    callback: () => modal.close(null),
                },
                {
                    label: 'Сохранить',
                    color: 'primary-accent',
                    size: 'large',
                    callback: () => {
                        const content = modal.getOverlayAttachComponentRef() as AiChatSessionRenameDialogComponent | undefined;
                        const value = content?.trimmedTitle ?? '';

                        if (!value) {
                            return;
                        }

                        modal.close(value);
                    },
                },
            ],
        });

        const sessionRef = modal.open();
        modal.setInputsToContentComponent({ titleValue: currentTitle });

        if (!sessionRef) {
            return of(null);
        }

        return sessionRef.afterClosing.pipe(
            take(1),
            map((result): string | null => (typeof result === 'string' && result.trim() ? result.trim() : null)),
        );
    }
}
